export default [
    {
        name: 'DT_AGENDA',
        label: 'Datas'
    },
];